// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RXxe","delete":"styles_delete__2Jd4L","update":"styles_update__eFm2v","add":"styles_add__1xU50"};